import { Link } from 'react-router-dom';
import { BOOK_TITLE, KINDLE_SELECT_MODE } from '../../lib/constants';

export function Footer() {
  return (
    <footer className="bg-text text-white/70 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-serif text-white/90 text-lg">{BOOK_TITLE}</p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm justify-center sm:justify-end">
            <a href="mailto:support@moneyskillsbook.com" className="hover:text-sage-light transition-colors">
              Support
            </a>
            <Link to="/privacy" className="hover:text-sage-light transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-sage-light transition-colors">
              Terms
            </Link>
            <Link to="/refund" className="hover:text-sage-light transition-colors">
              Refunds
            </Link>
            {!KINDLE_SELECT_MODE && (
              <Link to="/redeem" className="hover:text-sage-light transition-colors">
                Redeem Code
              </Link>
            )}
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-white/10 text-center text-sm relative">
          <p>&copy; {new Date().getFullYear()} Cuenca Ventures LLC. {BOOK_TITLE} is a Cuenca Ventures project.</p>
          <Link
            to="/play"
            aria-label="Play the Future You mini-game"
            title="Psst… there's a game in here."
            className="absolute right-0 top-1/2 -translate-y-1/2 text-white/20 hover:text-sage-light transition-all hover:scale-110 text-xl leading-none select-none"
          >
            🐷
          </Link>
        </div>
      </div>
    </footer>
  );
}
